import axios from "axios";

const deleteClinicEmployee = async (baseUrl, token, doctorId, empid) => {

    //doctor/{doctorid}/clinic/{clinicid}/room/{roomid}

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let deleteResponse = null

    await axios.delete(baseUrl + "/doctor/" + doctorId + "/employee/" + empid, config)
        .then((res) => {
            // console.log("res.data.data: ", res.data.data)
            deleteResponse = {
                status: res.data.status,
                data: res.data.data
            }

            // console.log("deleteResponse: ", deleteResponse)
        }).catch((error) => {
            if (error.response !== undefined) {
                deleteResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return deleteResponse
}

export default deleteClinicEmployee;